import React from "react";
import { useHistory } from "react-router-dom";
import './footer.scss';
import { EditIcon, DeleteIcon } from '../Icons';
import { AppContext } from '../../AppContext';

interface SessionFooterProps {
  tag: number;
};

const SessionFooter: React.SFC<SessionFooterProps> = (props) => {

  let history = useHistory();
  const [tagNumber, setTagNumber] = React.useState(props.tag);
  const context = React.useContext(AppContext);
  let state = context.state;

  const popState = () => {
    state.animals.pop();
    if(state.animals.length >= 1) {
      state.previous = {...state.animals[state.animals.length - 1]};
      setTagNumber(state.animals[state.animals.length - 1].tagNumber);
    } else {
      state.previous = {
        date: new Date(),
        herd: '',
        tagNumber: 0,
        tailCondition: '',
        activeInjury: false,
        highSevereCount: 0,
        highMildCount: 0,
        midSevereCount: 0,
        midMildCount: 0,
        lowSevereCount: 0,
        lowMildCount: 0,
        dockedPosition: '',
    }
      setTagNumber(0);
    }

    context.setState(state);
    localStorage.setItem('session', JSON.stringify(state));
  }

  const backHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if(window.confirm("Are you sure you want to re-enter "+tagNumber+"?")) {
      state.current = {...state.previous};
      popState();
      history.push('/tail_condition');
    }
  }

  const deleteHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    
    if(state.animals.length > 0) {
      if(window.confirm("Remove animal "+tagNumber+"?")) {
        popState();
      }
    }
  }

  return (
    <div className="footer">
      { (tagNumber > 0) &&
        <>
            <button className="footer_back" onClick={backHandler}><EditIcon fill="#ffffff" /></button>
            <div>
              Last Cow: {tagNumber}
            </div>
            <button className="footer_delete" onClick={deleteHandler}><DeleteIcon fill="#ffffff" /></button>
          </>
      }

    </div>
    )
}
export default SessionFooter;